export default __webpack_public_path__ + "static/media/logo-preview.5b8317b8.svg";